import React from 'react';
import PropTypes from 'prop-types';

import './style.scss';

const Icon = ({ icon, className, set, badge, badgeClassName, ...props }) => {
	// console.log('Icon', JSON.stringify(props));
	return <i className={(set ? set + '-' : 'admin-') + 'icon-' + icon + ' ' + (className || '')} {...props}>
		{badge !== null ? <span className={'badge ' + badgeClassName}>{badge}</span> : null}
	</i>;
};

Icon.propTypes = {
	icon: PropTypes.string.isRequired,
	badge: PropTypes.any,
	className: PropTypes.string,
	badgeClassName: PropTypes.string,
};

Icon.defaultProps = {
	badge: null,
	badgeClassName: '',
};

export default Icon;
